import {
  CRM_VIEW_ALL_LEAD,
  CRM_VIEW_ASSIGNED_LEAD,
  DASHBOARD_MODULE,
  DASHBOARD_PRO_MODULE,
  GENERATE_ACCOUNT_REPORT,
  GENERATE_CLIENT_REPORT,
  GENERATE_CRM_REPORT,
  GENERATE_DAILY_REPORT,
  GENERATE_EMPLOYEE_REPORT,
  GENERATE_EXPENSE_REPORT,
  GENERATE_MATERIAL_REPORT,
  GENERATE_PROJECT_REPORT,
  GENERATE_PURCHASE_REPORT,
  GENERATE_SUBCONTRACTOR_REPORT,
  GENERATE_TOOL_REPORT,
  GENERATE_USER_REPORT,
  GENERATE_VENDOR_REPORT,
  GENERATE_WORKER_REPORT,
  VIEW_ACCOUNT,
  VIEW_ASSIGNED_TASK,
  VIEW_CLIENT,
  VIEW_EMPLOYEE,
  VIEW_EXPENSE,
  VIEW_FINANCE_CATEGORY,
  VIEW_MATERIAL,
  VIEW_PERFORMANCE_GUARANTEE,
  VIEW_PROJECT,
  VIEW_ROLE,
  VIEW_STAGE,
  VIEW_SUBCONTRACTOR,
  VIEW_ALL_TASK,
  VIEW_TOOL,
  VIEW_USER,
  VIEW_VENDOR,
  VIEW_WORKER,
  VIEW_CUSTOM_INVOICE,
  CRM_PRO_VIEW_ALL_LEAD,
  CRM_PRO_VIEW_ASSIGNED_LEAD,
  VIEW_OFFICE_DASHBOARD,
} from "src/constants/permissions";
import { CRM_ROUTES } from "src/pages/crm/constants";
import { CRM_PRO_ROUTES } from "src/pages/crm-pro/constants";

export const sidebarData = {
  navs: [
    {
      title: "",
      menu: [
        {
          icon: "dashboard",
          text: "dashboard",
          href: "/dashboard",
          permissions: [DASHBOARD_MODULE, DASHBOARD_PRO_MODULE],
        },
        {
          icon: "leaderboard",
          text: "CRM",
          href: CRM_ROUTES.root,
          permissions: [CRM_VIEW_ALL_LEAD, CRM_VIEW_ASSIGNED_LEAD],
        },
        {
          icon: "leaderboard",
          text: "CRM Pro",
          href: CRM_PRO_ROUTES.dashboard,
          permissions: [CRM_PRO_VIEW_ALL_LEAD, CRM_PRO_VIEW_ASSIGNED_LEAD],
        },
        {
          icon: "folder_copy",
          text: "Projects",
          href: "/projects",
          permissions: [VIEW_PROJECT],
        },
        {
          icon: "corporate_fare",
          text: "Office Account",
          href: "/office/overview",
          permissions: [VIEW_OFFICE_DASHBOARD],
        },
        {
          icon: "engineering",
          text: "Workers",
          href: "/workers",
          permissions: [VIEW_WORKER],
        },
        {
          icon: "store",
          text: "Vendors",
          href: "/vendors",
          permissions: [VIEW_VENDOR],
        },
        {
          icon: "paid",
          text: "Expenses",
          href: "/expense",
          permissions: [VIEW_EXPENSE],
        },
        {
          icon: "group_add",
          text: "Subcontractors",
          href: "/subcontractors",
          permissions: [VIEW_SUBCONTRACTOR],
        },
        {
          icon: "person_outline",
          text: "clients",
          href: "/clients",
          permissions: [VIEW_CLIENT],
        },
        {
          icon: "groups",
          text: "employees",
          href: "/employees",
          permissions: [VIEW_EMPLOYEE],
        },
        {
          icon: "work",
          text: "Administration",
          href: "/administration",
          permissions: [VIEW_USER, VIEW_ROLE],
        },
        {
          icon: "book",
          text: "Library",
          href: "/library",
          permissions: [VIEW_FINANCE_CATEGORY, VIEW_MATERIAL, VIEW_STAGE],
        },
        {
          icon: "account_balance",
          text: "Account",
          href: "/accounts",
          permissions: [VIEW_ACCOUNT],
        },
        {
          icon: "task",
          text: "Tasks",
          href: "/tasks",
          permissions: [VIEW_ALL_TASK, VIEW_ASSIGNED_TASK],
        },
        {
          icon: "construction",
          text: "Tools",
          href: "/tools",
          permissions: [VIEW_TOOL],
        },
        {
          icon: "verified_user",
          text: "PG & AD PG",
          href: "/performance-guarantee",
          permissions: [VIEW_PERFORMANCE_GUARANTEE],
        },
        {
          icon: "receipt",
          text: "Invoices",
          href: "/invoices",
          permissions: [VIEW_CUSTOM_INVOICE],
        },
        {
          icon: "assessment",
          text: "Reports",
          href: "/reports",
          permissions: [
            GENERATE_DAILY_REPORT,
            GENERATE_CRM_REPORT,
            GENERATE_PROJECT_REPORT,
            GENERATE_WORKER_REPORT,
            GENERATE_VENDOR_REPORT,
            GENERATE_SUBCONTRACTOR_REPORT,
            GENERATE_CLIENT_REPORT,
            GENERATE_EMPLOYEE_REPORT,
            GENERATE_USER_REPORT,
            GENERATE_PURCHASE_REPORT,
            GENERATE_ACCOUNT_REPORT,
            GENERATE_TOOL_REPORT,
            GENERATE_MATERIAL_REPORT,
            GENERATE_EXPENSE_REPORT,
          ],
        },
      ],
    },
    {
      menu: [
        {
          icon: "business",
          text: "companies",
          href: "/companies",
        },
      ],
    },
  ],
  button: { icon: "lock", path: "/login", text: "logout" },
};
